import client from '../client'

export async function acceptOfferByBuyer({ directOfferId }) {
  return client(`${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/DirectOffers/AcceptOfferByBuyer`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ directOfferId }),
  })
}
